import React from 'react'
import { getDateInputmask } from 'servos/formValidations'
import PersonalDetailInput from './PersonalDetailInput'
import Card from '../../../commons/Card'

class PersonalDetails extends React.Component {

  componentDidMount() {
    getDateInputmask('dd/mm/yyyy', document.querySelector('#dateOfBirth'))
  }

  render() {
    const {
      errors,
      firstName,
      midName,
      lastName,
      dateOfBirth,
      handleInput,
    } = this.props

    return (
      <Card
        iconName='person'
        title='Personal details'
      >
        <div className='card-body'>
          <div className='row no-gutters'>
            <PersonalDetailInput
              id='firstName'
              label='First name'
              value={firstName}
              errorMessage={errors['firstName']}
              handleInput={handleInput}
            />
            <PersonalDetailInput
              id='midName'
              label='Middle name'
              value={midName}
              handleInput={handleInput}
            />
            <PersonalDetailInput
              id='lastName'
              label='Last name'
              value={lastName}
              errorMessage={errors['lastName']}
              handleInput={handleInput}
            />
          </div>
          <div className='row no-gutters'>
            <PersonalDetailInput
              id='dateOfBirth'
              label='Date of birth'
              value={dateOfBirth}
              errorMessage={errors['dateOfBirth']}
              handleInput={handleInput}
            />
          </div>
        </div>
      </Card>
    )
  }
}

export default PersonalDetails
